<template>
  <div>
    <WebHeaderView :title="$t('menu.active')" />
    <div class="page-content">
      <van-sticky :offset-top="46">
        <van-tabs
          @click="tabClick"
          v-model="active"
          color="#fff"
          title-active-color="#fff"
          style="margin-bottom: 10px"
        >
          <van-tab
            v-for="(item, index) in activitytype"
            :key="index"
            :name="item.id"
          >
        
         <template #title><div class="tab-title"><div v-if="item.red_dot == 1" class="dot" /> {{ item.name }} </div></template></van-tab>
        </van-tabs>
      </van-sticky>
      <div class="active-list">
        <div
          v-for="(item, index) in forData"
          :key="index"
          style="margin: 0px auto; width: 94%"
        >safeItem.red_dot == 1
          <ActiveItemView :item="item" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WebHeaderView from '@/components/Header/index.vue'
import { ActiveItemView } from './components/index'
export default {
  name: 'ActiveView',
  components: { WebHeaderView, ActiveItemView },
  data () {
    return {
      active: -1,
      activitylist: [],
      forData: [],
      activitytype: []
    }
  },
  mounted () {
    this.getactivitytype()
  },
  methods: {
    tabClick (val) {
      if (val == '-1') {
        this.forData = JSON.parse(JSON.stringify(this.activitylist))
      } else this.forData = this.activitylist.filter(e => e.type == val)
    },
    async getactivitytype () {
      await this.$http({
        method: 'post',
        url: 'activitytype'
      }).then(res => {
        this.activitytype = res.data
        this.activitytype.unshift({ name: '全部优惠', id: -1 })
        this.getactivitylist()
      })
    },
    async getactivitylist () {
      await this.$http({
        method: 'post',
        url: 'activitylist'
      }).then(res => {
        this.activitylist = res.data.data
        this.forData = JSON.parse(JSON.stringify(this.activitylist))
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .tab-title{
    padding: 1px 10px;
    position: relative;
    .dot{
      width: 8px;
      height: 8px;
      border: 1px solid #fff;
      border-radius: 50%;
      background: red;
      position: absolute;
      top: 0px;
      right: 0px;
    }
  }
.active-list {
  height: calc(100vh - 2.6rem);
  overflow-y: auto;
}
</style>
